// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_bot_inner-box{display:flex;align-items:center;position:relative}.header_bot .header_bot_inner-box .bot_nav_wrap,.header_bot_inner-box{justify-content:flex-start}", ""]);
// Exports
module.exports = exports;
